import React from "react";
import { Link } from "react-router-dom";
import { Check } from "../../assets/ThemeIcon";
import KycShape from "./components/KycShape";
const Kyc = () => {
	return (
		<>
			<section className="kyc-section">
				<div className="kyc-shape">
					<KycShape />
				</div>
				<div className="container">
					<div className="kyc-wrapper">
						<div className="kyc-content">
							<h2 className="title">KYC - Know Your Customer</h2>
							<p>
								KYC stands for "Know Your Customer". It's the process of
								ID verification of the customer. Everyone is required to
								pass the KYC procedure in order to participate in any of
								our launch pools. This is a necessary measure to ensure
								that the projects are doing business with legitimate
								entities.
							</p>
							<p>
								As this is an area not to be handled lightly, our KYC
								needs are handled by a recognised KYC verification and
								ID specialist -{" "}
								<a
									href="https://nuggets.life/"
									className="text-base"
									target="_blank"
									rel="noreferrer"
								>
									Nuggets.life
								</a>{" "}
								.
							</p>
							<p>
								In which to Apply for KYC Click “Register Now” below and
								this will take you to Nuggets Home, or if you are on a
								mobile device click to download the Nuggets app and
								register today! Once you’ve registered With Nuggets you
								can use this profile for verification on any of our
								projects (as well as across Nuggets widers system).
							</p>
							<div className="pt-sm-4">
								<Link to="/" className="btn btn-base">
									Register Now
								</Link>
							</div>
						</div>
						<div className="kyc-info">
							<ul>
								<li>
									<div className="item">
										<span>KYC Status:</span>
										<span className="text-base">Registered</span>
									</div>
									<div className="ms-3 me-4">
										<Check />
									</div>
								</li>
								<li>
									<div className="item">
										<span>Account Status:</span>
										<span className="text-base">Verified</span>
									</div>
									<div className="ms-3 me-4">
										<Check />
									</div>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default Kyc;
